import React from 'react';

import { cn } from '../helpers/cn';

export type InputLabelProps = {
    label: string | React.JSX.Element;
    labelStyle?: string;
    textSizeClassName?: string;
    requiredLabel?: boolean;
    htmlFor?: string;
};

function InputLabel(props: InputLabelProps): React.JSX.Element {
    return (
        <label
            htmlFor={props.htmlFor}
            className={cn('ml-2 mb-6 select-none', props.textSizeClassName || 'text-body-12', props.labelStyle)}>
            {props.label}
            <span className="text-red">{props.requiredLabel && ' *'}</span>
        </label>
    );
}

export default InputLabel;
